import {FINDER_OVERVIEW_CLEAR_SEARCH} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import clearSearchOrig from '~/frontend/src/actions/panel/dataTable/clearSearch';
import {getPanelProps} from '~/frontend/src/components/base/page/PageTabPanel/utilities';
import {getInitialSorters} from '~/shared/src/utilities/modules/finder';
import setParamOrig, {SetParamAction} from '~/frontend/src/actions/panel/common/setParam';
import unsetParamOrig, {UnsetParamAction} from '~/frontend/src/actions/panel/common/unsetParam';
import {ComponentProps} from '~/frontend/src/modules/panels/Finder/overview';


type SetParam = <K extends keyof ComponentProps>( panelKey : string, paramKey : K, paramValue : ComponentProps[K] ) => SetParamAction;
type UnsetParam = ( panelKey : string, paramKey : keyof ComponentProps ) => UnsetParamAction;


const setParam       = setParamOrig as SetParam,
      unsetParam     = unsetParamOrig as UnsetParam;


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {Function}
 */
const clearSearch = ( panelKey : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) : void => {
    const panelProps = getPanelProps( panelKey )?.panelProps;

    dispatch( {
        type: FINDER_OVERVIEW_CLEAR_SEARCH,
        panelKey
    } );

    dispatch( unsetParam( panelKey, 'status' ) );
    dispatch( unsetParam( panelKey, 'timestamp' ) );
    dispatch( unsetParam( panelKey, 'timezone' ) );

    dispatch( clearSearchOrig( panelKey ) );

    dispatch( setParam( panelKey, 'sorters', getInitialSorters( panelProps.dataStructure, panelProps.schema, panelProps.itemTypeName ) ) );
}
export type ClearSearch = typeof clearSearch;

export default clearSearch;
